import CompanyQuoteOverview from './CompanyQuoteOverview'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteOverviewContainer from './CompanyQuoteOverviewContainer'

export { CompanyQuoteOverview }
export default CompanyQuoteOverview
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteOverviewContainer }
// export default { CompanyQuoteOverviewContainer }
